export enum ControlSize {
    Default = "default",
    Large = "large",
    Medium = "medium",
    Small = "small",
}

